const htmlEntities = (str) => {
  return String(str)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
};
const htmlEntities_decode = (str) => {
  return String(str)
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, '"');
};
module.exports = { htmlEntities_decode, htmlEntities };



/** WEBPACK FOOTER **
 ** ./src/utils.js
 **/